export default "__VITE_PUBLIC_ASSET__536fb021__"